// Authentication URLs
export const LOGIN = "api/users/login";
export const PASSWORD_FORGET = "api/users/forgot-password";
export const RESET_PASSWORD = "api/users/reset-password";
export const EDIT_USER = "/api/users/update";
export const FETCH_PROFILE = "/api/users/me";

// Admin APIs (Shared)
export const ADMIN_LOGIN = "/api/admin/login";
export const ADMIN_PROFILE = "/api/admin/profile";
export const ADMIN_UPDATE = "/api/admin/update";
export const ADMIN_FORGOT_PASSWORD = "/api/admin/forgot-password";
export const ADMIN_RESET_PASSWORD = "/api/admin/reset-password";
export const USERS_URL = "/api/users/admin"; // User List
export const USER_DETAILS_URL = "/api/users/admin"; // :id
export const DELETE_USER_URL = "/api/users/admin"; // :id
export const USER_ACTIVITY_URL = "/api/admin/user-activity"; // ?gameType=lt or lt1
export const GENERAL_PNL_URL = "/api/admin/general-pnl"; // ?gameType=lt or lt1
export const EARNINGS_URL = "/api/admin/earnings"; // ?gameType=lt or lt1
export const GENERAL_DAILY_STATS_URL = "/api/admin/general-daily-stats";
export const GENERAL_WEEKLY_STATS_URL = "/api/admin/general-weekly-stats";
export const ALL_GAME_STATS_URL = "/api/admin/all-game-stats";

// --- Lucky Target (Game 1 - LT) ---
// Dashboard
export const LT_SETTINGS_URL = "/api/settings";
export const LT_MANUAL_WINNER_URL = "/api/settings/manual-winner";

// Joker
export const JOKER_SETTINGS_URL = "/api/joker";
export const JOKER_SESSION_URL = "/api/joker";
export const JOKER_PNL_URL = "/api/joker/pnl";

// --- Lucky Target 1 (Game 2 - LT1) ---
// Dashboard
export const LT1_SETTINGS_URL = "/lt1/api/settings";
export const LT1_MANUAL_WINNER_URL = "/lt1/api/settings/manual-winner";

// --- Lucky Target 3 (Game 5 - LT3) ---
// Dashboard
export const LT3_SETTINGS_URL = "/lt3/api/settings";
export const LT3_MANUAL_WINNER_URL = "/lt3/api/settings/manual-winner";

// --- American Roulette (Game 3 - RO) ---
// Dashboard
export const RO_SETTINGS_URL = "/api/ro/settings";
export const RO_MANUAL_WINNER_URL = "/api/ro/settings/manual-winner";

// --- Sorat ---
export const SO_SETTINGS_URL = "/api/sorat/admin/settings";
export const SO_MANUAL_WINNER_URL = "/api/sorat/settings/manual-winner"; // assuming similar path

// Legacy Exports (To be refactored/removed eventually, generic names mapped to LT default for now)
export const DASHBOARD_COUNT_URL = EARNINGS_URL; // Replaced specific hardcoded
export const SETTINGS_URL = LT_SETTINGS_URL;
export const SETTINGS_MULTIPLIER_URL = "/api/settings/multiplier"; // Check if used
export const MANUAL_WINNER_URL = LT_MANUAL_WINNER_URL;
export const USER_HISTORY_URL = "/api/admin/user-complete-activity"; // Keep if different from activity
export const JOKER_ROUNDS_URL = "/api/settings/joker-rounds"; // Deprecated?
export const GET_JOKER_SESSION = JOKER_SESSION_URL;
export const GET_JOKER_PNL = JOKER_PNL_URL;
export const GET_GENERAL_PNL = GENERAL_PNL_URL;
export const USER_HISTORY_LT1_URL = "/lt1/api/admin/user-complete-activity";
export const USER_HISTORY_LT3_URL = "/lt3/api/admin/user-complete-activity";
export const USER_HISTORY_RO_URL = "/api/admin/user-complete-activity";
export const USER_HISTORY_SO_URL = "/api/user/so-history";



// Withdrawal APIs
export const WITHDRAWAL_USERS_URL = "/api/admin/withdrawal/users";
export const WITHDRAWAL_ADD_COINS_URL = "/api/admin/withdrawal/add-coins";
export const WITHDRAWAL_REMOVE_COINS_URL = "/api/admin/withdrawal/remove-coins";
export const WITHDRAWAL_HISTORY_URL = "/api/users/withdrawal/history";
export const USER_TRANSACTIONS_URL = "/api/admin/transactions/user";
export const USER_BALANCE_HISTORY_URL = "/api/admin/user-balance-history";
export const USER_GAME_HISTORY_URL = "/api/admin/user-game-history";

// App Settings APIs
export const APP_SETTINGS_URL = "/api/app-settings";
export const GAMEPLAY_PARAMS_URL = "/api/app-settings/gameplay-params";
export const OPERATOR_GAMEPLAY_PARAMS_URL = "/api/app-settings/operator-gameplay-params";

// Operator Management
export const OPERATORS_URL = "/api/operator-management/operators";
export const OPERATOR_DROPDOWN_URL = "/api/operator-management/operators/dropdown";
export const USER_UPDATE_PASSWORD_URL = "/api/operator-management/users";
export const CREATE_USER_BY_OPERATOR_URL = "/api/operator-management/users/create-by-operator";
export const TRANSACTIONS_URL = "/api/transactions";
export const TRANSACTIONS_EXPORT_URL = "/api/admin/general-pnl";
export const DAY_REPORT_URL = "/api/admin/day-report";
export const OPERATOR_GAMES_STATS_URL = "/api/operator-management/operators"; // /:operatorId/games